<template>
    <div class="StockHoldingsPanel">
        <div class="stpTitle">Portfolios</div>
        <v-skeleton-loader v-if="!stock" type="image"></v-skeleton-loader>
        <div class="holding" v-for="(sh, i) in stockHoldings" :key="i">
            <SyPanel :title="sh.listName" icon="portfolio" :clickable="true" @titleClicked="viewPortfolio(sh.portfolioId)" :over="showIconOver(sh.lots)">
                <PortfolioStockLotWidgetMobile v-if="isMobile" :portfolioId="sh.portfolioId" :stockId="sh.stockId" :stockinfo="sh"></PortfolioStockLotWidgetMobile>
                <PortfolioStockLotWidget v-else :portfolioId="sh.portfolioId" :stockLots="sh.lots" :stock="sh" class="pfHoldings"></PortfolioStockLotWidget>
                <template v-slot:details v-if="!isMobile">
                    <div>{{sh.totalRemainingStockValueAndMoney}}</div>
                </template>
            </SyPanel>
        </div>
    </div>
</template>

<script>
import PortfolioStock from '../../models/PortfolioStock';
import SyPanel from '../controls/SyPanel.vue'
import StockMixin from '../stocks/StockMixin'
import PortfolioStockLotWidget from './PortfolioStockLotWidget.vue'
import PortfolioStockLotWidgetMobile from './PortfolioStockLotWidgetMobile.vue'
export default {
    components: { PortfolioStockLotWidget, PortfolioStockLotWidgetMobile, SyPanel },
    mixins: [StockMixin],
    computed: {
        stockHoldings() {
            if (!this.$store.getters.portfoliosLoaded) return []
            const sh = this.portfolioList.reduce((acc, cur) => {
                const ps = cur.stocks.find(s => s.stockId === this.stockId)
                if (ps) {
                    ps.listName = cur.name
                    ps.totalRemainingStockValueAndMoney = cur.totalRemainingStockValueAndMoney
                    acc.push(ps)
                }
                else {
                    const nps = new PortfolioStock({ portfolioId: cur.id, stockId: this.stockId })
                    nps.listName = cur.name
                    acc.push(nps)
                }
                return acc
            }, [])
            return sh
        },
        stockHoldings_old() {
            if (!this.$store.getters.portfoliosLoaded) return []
            const sh = Object.keys(this.$store.getters.userLists).reduce((acc, cur) => {
                if (cur === 'portfolios') {
                    const lists = this.$store.getters.userLists[cur]
                    lists.forEach(list => {
                        const ps = list.stocks.find(s => s.stockId === this.stockId)
                        if (ps) {
                            ps.listName = list.name
                            acc.push(ps)
                        }
                        else {
                            const nps = new PortfolioStock({ portfolioId: list.id, stockId: this.stockId })
                            nps.listName = list.name
                            acc.push(nps)
                        }
                    })
                }
                return acc
            }, [])
            return sh
        },
        portfolioList() {
            return this.$store.getters.portfolioList
        }
    },
    methods: {
        viewPortfolio(portfolioId) {
            this.$router.push({ name: 'Portfolio', params: { id: portfolioId } })
        },
        showIconOver(lots) {
            return lots.length === 0
        }
    }
}
</script>

<style lang="scss" scoped>
.StockHoldingsPanel {
    display: flex;
    flex-direction: column;
    gap: 10px;
    border: solid 1px #FFF;
    padding: 10px;
    .stpTitle {
        font-size: 1.2em;
        font-weight: bold;
        color: #FFF;
    }
    .holding {
        .pfHoldings {
            z-index: 1;
        }
    }
}
</style>